<template>
  <div class="index">
    <div class="container">
      <!-- banner + 右侧区块 -->
      <banner></banner>

      <!-- 主容器，左右布局开始 -->
      <div class="index-box">
        <!-- 左侧 -->
        <div class="index-l">
          <!-- 资讯区块1 -->
          <ac1></ac1>
          <!-- 资讯区块2 -->
          <ac2 :msrc="this.msrc"></ac2>
        </div>
        <!-- 右侧 -->
        <div class="index-r">
          <!-- 热门文章 -->
          <ac3></ac3>

          <!-- 文章列表 -->
          <ac4></ac4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "./../components/banner";
import ac1 from "./../components/ac1";
import ac2 from "./../components/ac2";
import ac3 from "./../components/ac3";
import ac4 from "./../components/ac4";
export default {
  name: "index",
  components: {
    banner,
    ac1,
    ac2,
    ac3,
    ac4,
  },
  data() {
    return {
      data: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
      msrc: "/mock/a1.json",
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.index {
  margin-top: 80px;
  background-color: #eee;
  .container {
    // height: 1920px;

    // 主容器
    .index-box {
      height: 100%;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      // 左侧
      .index-l {
        width: 70%;
        height: 100%;
        // background-color: pink;
      }
      // 右侧
      .index-r {
        width: 30%;
        margin-left: 40px;
        height: 100%;
        // background-color: #c60023;
      }
    }
  }
}
</style>